import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { AuthType } from '../../domain';
import { createAccountSettingsApi, accountApiRelativePath, authApiRelativePath } from './index';
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder, isWildcard } from '../../test-utils';
export var createAccountSettingsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAccountSettingsApi('', fakeHttp);
    var testKit = {
        whenGetAccountTimezone: function () {
            return createFakeGetResponder(fakeHttp, accountApiRelativePath + "/timezone");
        },
        whenSetAccountTimezone: function (dto) {
            return createFakePutResponder(fakeHttp, accountApiRelativePath + "/timezone")(dto);
        },
        whenGetAccountName: function () { return createFakeGetResponder(fakeHttp, accountApiRelativePath + "/name"); },
        whenSetAccountName: function (dto) {
            return createFakePutResponder(fakeHttp, accountApiRelativePath + "/name")(dto);
        },
        whenGetAccountLocales: function () {
            return createFakeGetResponder(fakeHttp, accountApiRelativePath + "/locales");
        },
        whenAddAccountLocale: function (dto) {
            return createFakePostResponder(fakeHttp, accountApiRelativePath + "/locales")(dto);
        },
        whenRemoveAccountLocale: function (dto) {
            return createFakeDeleteResponder(fakeHttp, accountApiRelativePath + "/locales/" + (isWildcard(dto) ? 'en' : dto.locale));
        },
        whenChangeAccountOwner: function (dto) {
            return createFakePutResponder(fakeHttp, accountApiRelativePath + "/owner")(dto);
        },
        whenGetSamlLoginSettings: function () { return createFakeGetResponder(fakeHttp, authApiRelativePath + "/providers?authType=" + AuthType.SAML + "&authMethodType=" + 0); },
        whenSetSamlLoginSettings: function (dto) { return createFakePostResponder(fakeHttp, authApiRelativePath + "/providers")(dto); },
        whenUpdateSamlLoginSettings: function (dto) { return createFakePutResponder(fakeHttp, authApiRelativePath + "/providers")(dto); },
        whenGetAuthenticationOptions: function () { return createFakeGetResponder(fakeHttp, accountApiRelativePath + "/login"); },
        whenEnableAuthProvider: function (dto) { return createFakePostResponder(fakeHttp, authApiRelativePath + "/providers/enable")(dto); },
        whenDisableAuthProvider: function (dto) { return createFakePostResponder(fakeHttp, authApiRelativePath + "/providers/disable")(dto); },
        whenToggleGoogleLogin: function (enabled) { return createFakePutResponder(fakeHttp, accountApiRelativePath + "/login/google/enabled")({ enabled: enabled }); },
        whenToggleInternalLogin: function (enabled) {
            return createFakePutResponder(fakeHttp, accountApiRelativePath + "/login/internal/enabled")({ enabled: enabled });
        },
        whenGetTenantEnabledChannels: function () { return createFakeGetResponder(fakeHttp, accountApiRelativePath + "/activities"); }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map